export default __webpack_public_path__ + "static/media/noPokemon.6284722a.jpg";